var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M8.999 0C4.068 0 .031 4.012 0 8.943c-.015 2.405.907 4.67 2.595 6.381 1.69 1.71 3.944 2.661 6.348 2.676H9c4.93 0 8.968-4.011 8.999-8.943C18.031 4.095 14.02.032 8.999 0zm.002 16.787v.606l-.05-.606c-2.08-.013-4.03-.836-5.492-2.315-1.462-1.48-2.258-3.44-2.245-5.521.026-4.267 3.519-7.738 7.835-7.738 4.293.028 7.764 3.543 7.738 7.836-.028 4.267-3.52 7.738-7.786 7.738z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M12.808 5.192c-.237-.237-.621-.237-.858 0L9 8.142l-2.95-2.95c-.236-.237-.62-.237-.857 0s-.237.621 0 .858L8.143 9l-2.95 2.95c-.237.237-.237.62 0 .858.118.118.273.178.429.178.155 0 .31-.06.429-.178L9 9.858l2.949 2.95c.119.118.274.178.429.178.155 0 .31-.06.429-.178.237-.237.237-.621 0-.858L9.858 9l2.95-2.95c.237-.237.237-.62 0-.858z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteClose);
export default __webpack_public_path__ + "static/media/deleteClose.879771a295508a7a1646565aeccbea23.svg";
export { ForwardRef as ReactComponent };